<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
	{{ message }}
</div>
<br />
<div mat-dialog-actions>
	<ws-button
		*ngFor="let action of actions"
		[text]="action.label"
		(click)="onActionClick(action.value, action.disabled)"
		[styleClass]="action.highlighted ? 'filled-button' : action.styleClass || 'outline-button'"
		[disabled]="!!action.disabled"
	></ws-button>
	<ws-button
		*ngIf="showCancel"
		[text]="cancelLabel"
		(click)="onCancel()"
		[styleClass]="cancelHighlighted ? 'filled-button' : 'outline-button'"
	></ws-button>
</div>
